import typeCheck from 'common/util/typeCheck';

import {
  SR_API_ACTION_LEASE_DRAFT_GET_PARTNER_CONFIGURATION,
} from 'api/actionTypes';

export default async function getPartnerDraftConfiguration(
  { state, apiClient },
  { partnerId }
) {
  typeCheck('partnerId::PositiveNumber', partnerId);

  const statePath = ['leases', 'configurationsByPartnerId', partnerId];
  if (state.get(statePath)) {
    return state.get(statePath);
  }

  return apiClient.postWithState({
    action: SR_API_ACTION_LEASE_DRAFT_GET_PARTNER_CONFIGURATION,
    state: state,
    payload: {
      partnerId,
    },
    onSuccess(partnerLeaseDraftConfiguration) {
      state.set(statePath, partnerLeaseDraftConfiguration);
    },
  });
}
